import { ReportReviewerStatus } from "@api/graphql/types-and-hooks";
import { useMyAuth0Id } from "@components/ReportReview/hooks/useMyAuth0Id";
import { useReportReviewers } from "@components/ReportReview/hooks/useReportReviewers";

export const useCanReviewReport = () => {
  const { reviewers } = useReportReviewers();
  const myId = useMyAuth0Id();
  return reviewers.find((item) => item.reviewer?.id === myId);
};

export const useCanRequestChanges = () => {
  const review = useCanReviewReport();
  return review && review?.status !== ReportReviewerStatus.ChangesRequested;
};

export const useCanWithdrawReview = () => {
  const review = useCanReviewReport();
  return (
    review?.status && [ReportReviewerStatus.ChangesRequested, ReportReviewerStatus.Approved].includes(review.status)
  );
};

export const useCanApprove = () => {
  const review = useCanReviewReport();
  return review && review?.status !== ReportReviewerStatus.Approved;
};
